import axios from 'lib/axios'

const getTest360Report = async (userTestId: number) => {
  const PATH = `${process.env.REACT_APP_MAIN_API}/pdf/test-360`
  const data = {
    user_test_id: userTestId,
  }
  try {
    const response = await axios.post(PATH, data)
    return response.data
  } catch (error) {
    console.error(error)
    return error
  }
}

export default getTest360Report
